module.exports = __webpack_public_path__ + "static/media/diflin.58095189.jfif";